export const baseUrl = window.location.origin.includes("srv-appdev01")
  ? window.location.origin + "/CISdev"
  : window.location.origin;

export const DayPickerStringsDE = {
  months: [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember",
  ],

  shortMonths: [
    "Jan",
    "Feb",
    "Mär",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez",
  ],

  days: [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag",
  ],

  shortDays: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],

  goToToday: "Gehe zu heute",
  prevMonthAriaLabel: "Gehe zum vorherigen Monat",
  nextMonthAriaLabel: "Gehe zum nächsten Monat",
  prevYearAriaLabel: "Gehe zum vorherigen Jahr",
  nextYearAriaLabel: "Gehe zum nächsten Jahr",

  isRequiredErrorMessage: "Datum wird benötigt.",
  invalidInputErrorMessage: "Ungültiges Datumsformat.",
};

export const DayPickerStringsEN = {
  months: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],

  shortMonths: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],

  days: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ],

  shortDays: ["S", "M", "T", "W", "T", "F", "S"],

  goToToday: "Go to today",
  prevMonthAriaLabel: "Go to previous month",
  nextMonthAriaLabel: "Go to next month",
  prevYearAriaLabel: "Go to previous year",
  nextYearAriaLabel: "Go to next year",

  isRequiredErrorMessage: "A date is required.",
  invalidInputErrorMessage: "Invalid date format.",
};
